import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'per-deduction-configuration',
    templateUrl: './per-deduction-configuration.component.html',
    styleUrls: ['./per-deduction-configuration.component.scss'],
    standalone: false
})
export class PerDeductionConfigurationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  displayInitialQuest: boolean = false;
  displayProgrammedQuest: boolean = false;

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    const pledge = this.subscriptionFacade.getPledge();
    this.initDisplayQuests(pledge);
  }

  initDisplayQuests(pledge: any) {
    const avInvestmentType =
      pledge?.products?.[0]?.parameters?.avInvestmentType;

    this.displayInitialQuest = ['INITIAL_AND_MONTHLY', 'INITIAL'].includes(
      avInvestmentType,
    );
    this.displayProgrammedQuest = ['INITIAL_AND_MONTHLY', 'MONTHLY'].includes(
      avInvestmentType,
    );

    if (!this.displayInitialQuest) {
      this.products
        .get(`${0}`)
        .get('parameters')
        .get('perEnabledTaxDeductibilityInitialInvestment')
        .setValidators([Validators.nullValidator]);
      this.form.updateValueAndValidity();
    }

    if (!this.displayProgrammedQuest) {
      this.products
        .get(`${0}`)
        .get('parameters')
        .get('perEnabledTaxDeductibilityProgrammedInvestment')
        .setValidators([Validators.nullValidator]);
      this.form.updateValueAndValidity();
    }
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
